import { FolderNode } from '../models/folder-node.models';

export const adjustFoldersForPayload = (
  folderStructure: FolderNode[]
): Partial<FolderNode>[] => {
  return folderStructure.map(({ id, name, pid, tp }) => ({
    id,
    name,
    pid,
    tp,
  }));
};
